const FormRow: React.FC<FormRowProps> = ({ children, extraClasses = '' }) => <div className={`form-row ${extraClasses}`}>{children}</div>;

interface FormRowProps {
    extraClasses?: string;
}

export default FormRow;
